import ChangeRequestApi from '~/common/api/zeiterfassungServerApi/ChangeRequestApi';
import JobTextRecordApi from '~/common/api/zeiterfassungServerApi/JobTextRecordApi';
import RoutineRecordApi from '~/common/api/zeiterfassungServerApi/RoutineRecordApi';
import JobPictureApi from '~/common/api/zeiterfassungServerApi/JobPictureApi';
import { NewJobApi } from '~/common/api/zeiterfassungServerApi/NewJobApi';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/tabs';
import { RoutineRecords } from './RoutineRecordsWithPictures';
import { ProjectRecordsTab } from './ProjectRecords';
import useTranslate from '~/common/utils/translate';
import { ActiveEmployees } from './ActiveEmployees';
import { ChangeRequests } from './ChangeRequests';
import { TextRecords } from './TextRecords';
import { useEffect, useState } from 'react';
import { Badge } from '@chakra-ui/react';
import { NewImages } from './NewImages';
import NewJobs from './NewJobs';

const Dashboard = () => {
  const t = useTranslate();
  const savedTabIndex = localStorage.getItem('dashboardTabIndex');
  const initialTabIndex = savedTabIndex ? parseInt(savedTabIndex, 10) : 0;
  const [tabIndex, setTabIndex] = useState(initialTabIndex);
  const { data: changeRequestCount = 0 } =
    ChangeRequestApi.hooks.useChangeRequestCount({
      refetchInterval: 1000 * 5,
    });

  const [{ data: newJobCount }] = NewJobApi.hooks.useNewJobRecordCount({
    refetchInterval: 1000 * 60,
  });

  const [{ data: newImagesCount }] =
    JobPictureApi.hooks.useUnacceptedPicturesCount({
      refetchInterval: 1000 * 60,
    });

  const [{ data: newTextCount }] = JobTextRecordApi.hooks.useTextRecordCount({
    refetchInterval: 1000 * 60,
  });

  const { data: routineRecordWithPicturesCount } =
    RoutineRecordApi.hooks.useRoutinesWithPicturesCount({
      refetchInterval: 1000 * 60,
    });

  useEffect(() => {
    const timeout = setTimeout(() => {
      localStorage.setItem('dashboardTabIndex', '0');
    }, 120000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Tabs isLazy isFitted index={tabIndex}>
      <TabList
        position="fixed"
        top="auto"
        mt={2}
        ml={-4}
        w="100%"
        zIndex={10}
        bg="white"
        boxShadow="md"
      >
        <Tab
          onClick={() => {
            localStorage.setItem('dashboardTabIndex', '0');
            setTabIndex(0);
          }}
        >
          {t('dashboard.employees.active')}
        </Tab>
        <Tab
          onClick={() => {
            localStorage.setItem('dashboardTabIndex', '1');
            setTabIndex(1);
          }}
        >
          {' '}
          {t('dashboard.newjobs')}
          <Badge ml={2} variant="outline" colorScheme="green">
            {newJobCount?.count ?? 0}
          </Badge>
        </Tab>
        <Tab
          onClick={() => {
            localStorage.setItem('dashboardTabIndex', '2');
            setTabIndex(2);
          }}
        >
          {' '}
          {t('dashboard.newtext')}
          <Badge ml={2} variant="outline" colorScheme="green">
            {newTextCount?.count ?? 0}
          </Badge>
        </Tab>
        <Tab
          onClick={() => {
            localStorage.setItem('dashboardTabIndex', '3');
            setTabIndex(3);
          }}
        >
          {' '}
          {t('dashboard.routinePictures')}
          <Badge ml={2} variant="outline" colorScheme="green">
            {routineRecordWithPicturesCount ?? 0}
          </Badge>
        </Tab>
        <Tab
          onClick={() => {
            localStorage.setItem('dashboardTabIndex', '4');
            setTabIndex(4);
          }}
        >
          {t('changeRequest.dashboard')}
          <Badge ml={2} variant="outline" colorScheme="green">
            {changeRequestCount ?? 0}
          </Badge>
        </Tab>
        <Tab
          onClick={() => {
            localStorage.setItem('dashboardTabIndex', '5');
            setTabIndex(5);
          }}
        >
          {' '}
          {t('dashboard.newimages.heading')}
          <Badge ml={2} variant="outline" colorScheme="green">
            {newImagesCount?.count ?? 0}
          </Badge>
        </Tab>
        <Tab
          onClick={() => {
            localStorage.setItem('dashboardTabIndex', '6');
            setTabIndex(6);
          }}
        >
          {t('dashboard.tabs.projectRecords')}
        </Tab>
      </TabList>
      <TabPanels mt={16}>
        <TabPanel>{tabIndex === 0 && <ActiveEmployees />}</TabPanel>
        <TabPanel>{tabIndex === 1 && <NewJobs />}</TabPanel>
        <TabPanel>{tabIndex === 2 && <TextRecords />}</TabPanel>
        <TabPanel>{tabIndex === 3 && <RoutineRecords />}</TabPanel>
        <TabPanel>{tabIndex === 4 && <ChangeRequests />}</TabPanel>
        <TabPanel>{tabIndex === 5 && <NewImages />}</TabPanel>
        <TabPanel>{tabIndex === 6 && <ProjectRecordsTab />}</TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default Dashboard;
